import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import UnlinkedTransferAccountsPage, { getDefaultData, getDefaultUI } from "components/pages/UnlinkedTransferAccountsPage";
import AddUnlinkedTransferAccountForm from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountForm";
import AddUnlinkedTransferAccountFormUI from "components/workflows/AddUnlinkedTransferAccountWorkflow/classes/AddUnlinkedTransferAccountFormUI";
import Classes, { Account } from "model";

/**
 * @name CaptureCrossAccountAddedToList
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureCrossAccountAddedToList(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasConsumerAccounts = Account.hasConsumerAccounts(branding);
    const defaultUnlinkedAcc = BCMSDefaultModel.unlinkedAccount();
    const newAccountNumber = "1500306800";
    defaultUnlinkedAcc.id = "100";
    defaultUnlinkedAcc.nickname = defaultUnlinkedAcc.accountOwnerFirstName;
    defaultUnlinkedAcc.accountOwnerType = hasConsumerAccounts ? "personal" : "business";
    defaultUnlinkedAcc.number = Account.formatAccountNumber(newAccountNumber);

    const form = AddUnlinkedTransferAccountForm.init({
        accountNickname: defaultUnlinkedAcc.accountOwnerFirstName,
        accountOwnerType: defaultUnlinkedAcc.accountOwnerType,
        firstNameOfAccountOwner: defaultUnlinkedAcc.accountOwnerFirstName,
        lastNameOfAccountOwner: defaultUnlinkedAcc.accountOwnerLastName,
        accountType: defaultUnlinkedAcc.subtype,
        accountNumber: newAccountNumber,
        confirmAccountNumber: newAccountNumber
    }, branding);

    // This formUI class handles shown/removed fields from branding.
    const formUI = AddUnlinkedTransferAccountFormUI.init(form, branding);

    defaultUnlinkedAcc.accountOwnerFirstName = formUI.firstNameOfAccountOwner ? defaultUnlinkedAcc.accountOwnerFirstName : "";
    defaultUnlinkedAcc.accountOwnerLastName = formUI.lastNameOfAccountOwner ? defaultUnlinkedAcc.accountOwnerLastName : "";
    defaultUnlinkedAcc.accountOwnerType = formUI.accountOwnerType ? defaultUnlinkedAcc.accountOwnerType : "";

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "successfullyAddedUnlinkedAccount" ], { isActive: true })
    .submit();

    const defaultData = getDefaultData(context);
    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "accounts" ], [ defaultUnlinkedAcc, ...defaultData.accounts ])
    .update([ "addedUnlinkedAccount" ], defaultUnlinkedAcc)
    .submit();

    return <UnlinkedTransferAccountsPage data={ data } ui={ ui } />;
}